{
  "id": "b2-vocabulary-19",
  "name": "B2 Frequency Band 19 (901-950)",
  "description": "B2 level French frequency vocabulary",
  "examGrade": "B2",
  "difficulty": "advanced",
  "source": "French subtitle frequency list",
  "sourceUrl": "https://github.com/hermitdave/FrequencyWords",
  "category": "general",
  "words": [
    {
      "id": "fr:vocab:3902:grandir",
      "word": "grandir",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4845
    },
    {
      "id": "fr:vocab:3903:pr-f-rerais",
      "word": "préférerais",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4844
    },
    {
      "id": "fr:vocab:3904:feux",
      "word": "feux",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4842
    },
    {
      "id": "fr:vocab:3905:d-pass",
      "word": "dépassé",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4841
    },
    {
      "id": "fr:vocab:3906:tuez",
      "word": "tuez",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4841
    },
    {
      "id": "fr:vocab:3907:faut-il",
      "word": "faut-il",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4840
    },
    {
      "id": "fr:vocab:3908:passant",
      "word": "passant",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4839
    },
    {
      "id": "fr:vocab:3909:totale",
      "word": "totale",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4837
    },
    {
      "id": "fr:vocab:3910:rencontr-e",
      "word": "rencontrée",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4835
    },
    {
      "id": "fr:vocab:3911:pro",
      "word": "pro",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4834
    },
    {
      "id": "fr:vocab:3912:carrie",
      "word": "carrie",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4833
    },
    {
      "id": "fr:vocab:3913:m-chante",
      "word": "méchante",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4833
    },
    {
      "id": "fr:vocab:3914:ressentir",
      "word": "ressentir",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4831
    },
    {
      "id": "fr:vocab:3915:d-clar",
      "word": "déclaré",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4825
    },
    {
      "id": "fr:vocab:3916:dessin",
      "word": "dessin",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4824
    },
    {
      "id": "fr:vocab:3917:g-n-reux",
      "word": "généreux",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4816
    },
    {
      "id": "fr:vocab:3918:attendons",
      "word": "attendons",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4816
    },
    {
      "id": "fr:vocab:3919:bourr",
      "word": "bourré",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4815
    },
    {
      "id": "fr:vocab:3920:mn",
      "word": "mn",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4814
    },
    {
      "id": "fr:vocab:3921:manuel",
      "word": "manuel",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4813
    },
    {
      "id": "fr:vocab:3922:officiel",
      "word": "officiel",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4810
    },
    {
      "id": "fr:vocab:3923:reconnaissance",
      "word": "reconnaissance",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4810
    },
    {
      "id": "fr:vocab:3924:boisson",
      "word": "boisson",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4805
    },
    {
      "id": "fr:vocab:3925:embrass",
      "word": "embrassé",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4805
    },
    {
      "id": "fr:vocab:3926:savaient",
      "word": "savaient",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4804
    },
    {
      "id": "fr:vocab:3927:app-tit",
      "word": "appétit",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4803
    },
    {
      "id": "fr:vocab:3928:commandes",
      "word": "commandes",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4802
    },
    {
      "id": "fr:vocab:3929:d-couverte",
      "word": "découverte",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4800
    },
    {
      "id": "fr:vocab:3930:risquer",
      "word": "risquer",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4800
    },
    {
      "id": "fr:vocab:3931:entendue",
      "word": "entendue",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4800
    },
    {
      "id": "fr:vocab:3932:excit",
      "word": "excité",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4800
    },
    {
      "id": "fr:vocab:3933:rouler",
      "word": "rouler",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4797
    },
    {
      "id": "fr:vocab:3934:c-ble",
      "word": "câble",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4793
    },
    {
      "id": "fr:vocab:3935:fume",
      "word": "fume",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4792
    },
    {
      "id": "fr:vocab:3936:phrase",
      "word": "phrase",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4792
    },
    {
      "id": "fr:vocab:3937:r-veil",
      "word": "réveil",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4787
    },
    {
      "id": "fr:vocab:3938:av-re",
      "word": "avère",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4783
    },
    {
      "id": "fr:vocab:3939:champs",
      "word": "champs",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4782
    },
    {
      "id": "fr:vocab:3940:disponible",
      "word": "disponible",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4782
    },
    {
      "id": "fr:vocab:3941:lev",
      "word": "levé",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4778
    },
    {
      "id": "fr:vocab:3942:julian",
      "word": "julian",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4778
    },
    {
      "id": "fr:vocab:3943:dose",
      "word": "dose",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4777
    },
    {
      "id": "fr:vocab:3944:coma",
      "word": "coma",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4776
    },
    {
      "id": "fr:vocab:3945:cuisiner",
      "word": "cuisiner",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4772
    },
    {
      "id": "fr:vocab:3946:groupes",
      "word": "groupes",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4770
    },
    {
      "id": "fr:vocab:3947:envoy-e",
      "word": "envoyée",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4768
    },
    {
      "id": "fr:vocab:3948:d-p-che",
      "word": "dépêche",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4767
    },
    {
      "id": "fr:vocab:3949:sociale",
      "word": "sociale",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4766
    },
    {
      "id": "fr:vocab:3950:assister",
      "word": "assister",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4766
    },
    {
      "id": "fr:vocab:3951:comptez",
      "word": "comptez",
      "translation": "",
      "partOfSpeech": "",
      "examGrade": "B2",
      "frequency": 4765
    }
  ]
}